import * as yup from "yup";

export const criarLoteGPSchema = yup.object({
  idBeneficiario: yup
    .number()
    .typeError("O beneficiário é obrigatório")
    .required("O beneficiário é obrigatório")
    .min(0, "O beneficiário é obrigatório"),
  numeroNfRecibo: yup
    .string()
    .required("O número do recibo / NF é obrigatório"),
  valorNfRecibo: yup
    .string()
    .required("O valor é obrigatório")
    .test("valor", "O valor é obrigatório", (v) => !["", "0.00"].includes(v ?? "")),
});
